export default "__VITE_ASSET__DxKBRkuH__"